import { redirect } from "react-router-dom";

export function getAvatar() {
  const avatar = localStorage.getItem("avatar");

  if (!avatar) {
    return;
  }

  return avatar;
}

export function getAuthToken() {
  const token = localStorage.getItem("token");
  const loginTime = localStorage.getItem("login_time");

  if (!loginTime || !token) {
    return null;
  }

  const now = Date.now();
  const diff = now - parseInt(loginTime);
  const twentyFourHours = 24 * 60 * 60 * 1000;

  if (diff > twentyFourHours) {
    localStorage.removeItem("token");
    localStorage.removeItem("approved");
    localStorage.removeItem("role");
    localStorage.removeItem("id");
    localStorage.removeItem("login_time");
    localStorage.removeItem("avatar");
    return null;
  }

  return token;
}

export function tokenLoader() {
  return getAuthToken();
}

export function checkAuthToken() {
  const token = getAuthToken();

  if (!token) {
    return redirect("/login");
  }

  return null;
}

export function checkAuthForProfessionals() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const approved = localStorage.getItem("approved");

  if (!token) return redirect("/login");
  if (role === "company") return redirect("/");

  if (role === "employee") {
    if (approved === "0") return redirect("/professionals-approval");
  }
}

export function checkAuthForCompany() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const approved = localStorage.getItem("approved");

  if (!token) return redirect("/login");
  if (role === "employee") return redirect("/");

  if (role === "company") {
    if (approved === "0") return redirect("/company-approval");
    if (approved === "1") return redirect("/company-under-review");
  }
}

export function checkAuthForLogin() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const approved = localStorage.getItem("approved");
  const id = localStorage.getItem("id");
  if (!token) return null;
  if (role === "employee") {
    if (approved === "2") return redirect("/");
  }
  if (role === "company") {
    if (approved === "1") return redirect("/");
  }
  return null;
}

export function checkEmployeeAccess() {
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  if (!token || role !== "employee") {
    return redirect("/login");
  }

  return null;
}

export function checkCompanyAccess() {
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  if (!token || role !== "company") {
    return redirect("/login");
  }

  return null;
}

export function checkCompanyReview() {
  const role = localStorage.getItem("role");
  const approved = localStorage.getItem("approved");

  if (role === "company" && approved == "2") {
    return redirect("/");
  }
}

export function getUserId() {
  const userId = localStorage.getItem("id");

  return userId;
}

export function getUserRole() {
  const role = localStorage.getItem("role");

  return role;
}

export function checkLoggedInUsers() {
  const token = localStorage.getItem("token");

  if (token) {
    return redirect("/");
  }
}

// admin

export function getAdminAuthToken() {
  const adminToken = localStorage.getItem("admin_token");
  const loginTime = localStorage.getItem("admin_login_time");

  if (!loginTime || !adminToken) {
    return null;
  }

  const now = Date.now();
  const diff = now - parseInt(loginTime);
  const twentyFourHours = 24 * 60 * 60 * 1000;

  if (diff > twentyFourHours) {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_login_time");
    localStorage.removeItem("admin_role");
    localStorage.removeItem("admin_id");
    return null;
  }

  return adminToken;
}

export function tokenAdminLoader() {
  return getAdminAuthToken();
}

export function checkAdminAuth() {
  const adminToken = localStorage.getItem("admin_token");

  if (!adminToken) {
    return redirect("/admin/login");
  }
}
export function checkAdminIsLogged() {
  const adminToken = localStorage.getItem("admin_token");

  if (adminToken) {
    return redirect("/admin/dashboard");
  }
}
